import React, { useState, useEffect, useRef } from "react";

//import React, { useState, useEffect } from "react";
import axios from "axios";

const OddsAgainstsUs = () => {
  const [pincode, setPincode] = useState("");
  const [villages, setVillages] = useState([]);
  const [selectedVillageIndex, setSelectedVillageIndex] = useState(0);
  const [error, setError] = useState("");
  const villageDivRef = useRef(null);

  useEffect(() => {
    const handlePincodeSync = (event) => {
      const { pincode } = event.detail;
      console.log("📥 Received pincode from OrderCreate:", pincode);
      setPincode(pincode); // Don't call submit yet!
    };

    window.addEventListener("pincodeSync", handlePincodeSync);
    return () => {
      window.removeEventListener("pincodeSync", handlePincodeSync);
    };
  }, []);

  // ✅ Fetch only after state is updated
  useEffect(() => {
    if (!pincode || !/^\d{6}$/.test(pincode)) return;

    console.log("📡 Triggering API call for PIN:", pincode);
    handlePincodeSubmit(pincode);
  }, [pincode]);

  const handlePincodeSubmit = async (pincodeValue) => {
    setError("");
    setVillages([]);
    setSelectedVillageIndex(0);

    if (!/^\d{6}$/.test(pincodeValue)) {
      setError("Please enter a valid 6-digit PIN code.");
      return;
    }

    try {
      const response = await axios.get(`https://astrovidhya.in/api/villages/${pincodeValue}`);
      let { villages } = response.data;

      if (villages && villages.length > 0) {
        const sortedVillages = villages.sort((a, b) => a.localeCompare(b));
        setVillages(sortedVillages);
        console.log("✅ Villages received:", sortedVillages);

        // Auto-select first and dispatch event to OrderCreate
        window.dispatchEvent(new CustomEvent("villageSelected", { detail: { village: sortedVillages[0] } }));
      } else {
        setError("No villages found for the entered PIN code.");
      }
    } catch (err) {
      console.error("Error fetching villages:", err);
      setError("Failed to fetch villages. Please try again later.");
    }
  };

  const handleKeyDown = (event) => {
    if (villages.length === 0) return;

    if (event.key === "ArrowDown") {
      setSelectedVillageIndex((prevIndex) => (prevIndex + 1) % villages.length);
    } else if (event.key === "ArrowUp") {
      setSelectedVillageIndex((prevIndex) => (prevIndex - 1 + villages.length) % villages.length);
    } else if (event.key === "Enter") {
      handleVillageClick(villages[selectedVillageIndex]);
    }
  };

  const handleVillageClick = (village) => {
    console.log("📢 Dispatching villageSelected event:", village);

    window.dispatchEvent(new CustomEvent("villageSelected", { detail: { village } }));

    requestAnimationFrame(() => {
      setTimeout(() => {
        const orderForm = document.getElementById("orderCreateForm");
        if (orderForm) {
          orderForm.focus();
          console.log("✅ Focus returned to OrderCreateForm!");
        } else {
          console.log("❌ OrderCreateForm not found!");
        }
      }, 100);
    });
  };

  useEffect(() => {
    const handleShortcut = (event) => {
      if (event.shiftKey && event.key.toLowerCase() === "o") {
        event.preventDefault();
        const orderForm = document.getElementById("orderCreateForm");
        if (orderForm) {
          orderForm.focus();
          console.log("🔄 Focused back to OrderCreateForm");
        }
      }
    };

    window.addEventListener("keydown", handleShortcut);
    return () => {
      window.removeEventListener("keydown", handleShortcut);
    };
  }, []);

  useEffect(() => {
    const handleVillagePanelFocus = () => {
      setTimeout(() => {
        villageDivRef.current?.focus();
        console.log("🟢 Focused actual visible village list");
      }, 100);
    };
  
    window.addEventListener("focusVillagePanel", handleVillagePanelFocus);
    return () => {
      window.removeEventListener("focusVillagePanel", handleVillagePanelFocus);
    };
  }, []);
  

  return (
    <div
      id="villageListPanel"
      tabIndex={0}
      ref={villageDivRef} // ✅ Add this
      className="odds-against-us bg-white p-6 rounded-lg shadow-md"
      onKeyDown={handleKeyDown}
      onFocus={() => {
        console.log("✅ Village Panel Focused");
      }}
    >
      <h2 className="text-lg font-bold mb-4">Find Villages by PIN Code</h2>

      {error && <p className="text-red-500 mb-4">{error}</p>}

      {villages.length > 0 && (
        <div className="village-table">
          <h3 className="text-md font-semibold mb-2">Villages:</h3>
          <table className="table-auto w-full border-collapse border border-gray-300">
            <thead>
              <tr className="bg-gray-200">
                <th className="border border-gray-300 px-4 py-2 text-left">#</th>
                <th className="border border-gray-300 px-4 py-2 text-left">Village</th>
              </tr>
            </thead>
            <tbody>
              {villages.map((village, index) => (
                <tr
                  key={index}
                  tabIndex={0}
                  className={`hover:bg-gray-100 cursor-pointer ${
                    selectedVillageIndex === index ? "bg-blue-200" : ""
                  }`}
                  onClick={() => handleVillageClick(village)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") handleVillageClick(village);
                  }}
                >
                  <td className="border border-gray-300 px-4 py-2">{index + 1}</td>
                  <td className="border border-gray-300 px-4 py-2">{village}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default OddsAgainstsUs;
